var AngelModule = /** @class */ (function () {
    function AngelModule() {
    }
    return AngelModule;
}());
export { AngelModule };
